import httpConfig from '@/api/config';
import axios from 'axios';
import {Message} from 'element-ui';
import Qs from 'qs'
import router from '@/router/index'

//创建错误拦截器
axios.interceptors.response.use(function (res) {
  let data = res.data;
  if (data.code === 10007) {
    Message.error({
      message: '您的登录信息不正确，请重新登录',
      onClose: function () {
        localStorage.removeItem('user');
        router.replace({name: 'login'});
      }
    });
    return false;
  }
  if (data.status === 'fail') {
    Message.error({
      message: data.message
    });
    return false;
  }
  return data;
}, function (error) {
  Message.error({
    message: '服务器连接失败，请检查网络。'
  });
  return Promise.reject(error);
});

/**
 * 解析api配置信息
 * @param apiName
 * @returns {{url: string, method: *|string|string|SVGAnimatedEnumeration}}
 */
function parseApiConfig(apiName, domain) {
  let api = httpConfig.apiList[apiName];
  if (!domain) {
    domain = httpConfig.apiDomain;
  }
  let url = domain + api.url;
  url = httpConfig.isHttps ? "https://" + url : "http://" + url;
  let method = api.method;
  return {url, method}
}


/**
 * 构造http请求对象
 * @type {{request: http.request}}
 */
const http = {
  request: function (apiName, params = {},getUrl = false) {
    let apiConfig = parseApiConfig(apiName);
    let axiosConfig = {
      url: apiConfig.url,
      timeout: httpConfig.timeout,
      method: apiConfig.method,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    };
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      params.api_token = user.api_token;
    }
    if (apiName === 'intelligentChat' && apiConfig.method.toLowerCase() === 'post') {
      axiosConfig.headers['Content-Type'] = 'application/json; charset=utf-8'
      axiosConfig.data = JSON.stringify(params)
      axiosConfig.timeout = 120000
    } else if (apiConfig.method.toLowerCase() === 'post') {
      axiosConfig.data = Qs.stringify(params)
    } else {
      axiosConfig.params = params
    }
    if(getUrl){
      let query = "";
      for (const key in params){
        if(key === 'filter'){
          params[key] = JSON.stringify(params[key]);
        }
        query +=key+"="+params[key]+"&";
      }
      return axiosConfig.url + "?"+query;
    }
    return axios(axiosConfig);
  },
  upload: function (formData) {
    let apiConfig = parseApiConfig('upload', httpConfig.fileDomain);
    let axiosConfig = {
      data: formData,
      url: apiConfig.url,
      timeout: httpConfig.timeout,
      method: apiConfig.method,
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    };
    return axios(axiosConfig);
  }
}
export default http;



// WEBPACK FOOTER //
// ./src/api/http.js